import { defineMessages } from 'react-intl';

export default defineMessages({
  orderInclusiveTax: {
    id: 'order.inclusiveTax',
    defaultMessage: '消费税(已包含)',
  },
  orderStatusIng: {
    id: 'order.status.ing',
    defaultMessage: '未完成',
  },
  orderStatusDone: {
    id: 'order.status.done',
    defaultMessage: '已完成',
  },
  uncheckRecommendation: {
    id: 'order.uncheckRecommendation',
    defaultMessage: '大厨拿手菜',
  },
  orderSerialNo: {
    id: 'order.serialNo',
    defaultMessage: '流水号',
  },
  orderWholeNotes: {
    id: 'order.wholeNotes',
    defaultMessage: '整单备注',
  },
  orderUncheckMessageOne: {
    id: 'order.uncheckMessageOne',
    defaultMessage: '订单已提交，等待商家确认',
  },
  orderUncheckMessageTwo: {
    id: 'order.uncheckMessageTwo',
    defaultMessage: '商户已接单，祝您用餐愉快！',
  },
  orderSurChargeAmount: {
    id: 'order.uncheck.suerChargeAmount',
    defaultMessage: '附加费总计',
  },
  orderPrivilegeAmount: {
    id: 'order.privilegeAmount',
    defaultMessage: '优惠总计',
  },
  orderCommodities: {
    id: 'order.commodities',
    defaultMessage: '商品',
  },
  orderProceedToCheckout: {
    id: 'order.proceedToCheckout',
    defaultMessage: '去结账',
  },
  orderWaiter: {
    id: 'order.Waiter',
    defaultMessage: '服务员',
  },
  orderPicked: {
    id: 'order.picked',
    defaultMessage: '已选商品',
  },
  orderTotalDishes: {
    id: 'order.totalDishes',
    defaultMessage: '共{count}份',
  },
  limitDishesCount: {
    id: 'order.limitDishesCount',
    defaultMessage: '仅限{count}份',
  },
  modifyOrder: {
    id: 'order.modifyOrder',
    defaultMessage: '修改订单',
  },
  orderGift: {
    id: 'order.gift',
    defaultMessage: '送',
  },
  memberPrivilege: {
    id: 'order.memberPrivilege',
    defaultMessage: '会员优惠',
  },
  rightsCardPrivilege: {
    id: 'order.rightsCardPrivilege',
    defaultMessage: '折扣卡优惠',
  },
  deductScore: {
    id: 'order.deductScore',
    defaultMessage: '抵扣{privilegeValue}积分',
  },
  deductScore1: {
    id: 'order.deductScore1',
    defaultMessage: '抵扣{privilegeValue}捞币',
  },
  activityPrivilege: {
    id: 'order.activityPrivilege',
    defaultMessage: '活动优惠',
  },
  limitPrivilege: {
    id: 'order.limitPrivilege',
    defaultMessage: '限免优惠',
  },
  giftPrivilegeName: {
    id: 'order.giftPrivilegeName',
    defaultMessage: '礼品券-赠送{privilegeName}',
  },
  giftPrivilege: {
    id: 'order.giftPrivilege',
    defaultMessage: '礼品券',
  },
  elsePrivilege: {
    id: 'order.elsePrivilege',
    defaultMessage: '其他优惠',
  },
  inUseCards: {
    id: 'order.inUseCards',
    defaultMessage: '已选{count}张',
  },
  canUseCards: {
    id: 'order.canUseCards',
    defaultMessage: '{count}张可用',
  },
  useCardsTitle: {
    id: 'order.useCardsTitle',
    defaultMessage: '使用礼品卡',
  },
  useCouponsTitle: {
    id: 'order.useCouponsTitle',
    defaultMessage: '使用优惠券',
  },
  freeDeliveryPrice: {
    id: 'order.freeDeliveryPrice',
    defaultMessage: '满{currency}{freeDeliveryPrice}减免配送费',
  },
  couponGiftName: {
    id: 'order.couponGiftName',
    defaultMessage: '优惠券优惠{giftName}',
  },
  cardsReduct: {
    id: 'order.cardsReduct',
    defaultMessage: '礼品卡抵扣',
  },
  primaryPrice: {
    id: 'order.primaryPrice',
    defaultMessage: '原价',
  },
  goodsPrice: {
    id: 'order.goodsPrice',
    defaultMessage: '商品金额',
  },
  includeTaxPrice: {
    id: 'order.includeTaxPrice',
    defaultMessage: '含税价',
  },
  floorPrice: {
    id: 'order.floorPrice',
    defaultMessage: '自动抹零',
  },
  adjustPrice: {
    id: 'order.adjustPrice',
    defaultMessage: '尾数调整',
  },
  totalDiscout: {
    id: 'order.totalDiscout',
    defaultMessage: '共优惠',
  },
  orderTotal: {
    id: 'order.orderTotal',
    defaultMessage: '共计',
  },
  orderTime: {
    id: 'order.orderTime',
    defaultMessage: '下单时间',
  },
  earnestMoney: {
    id: 'order.earnestMoney',
    defaultMessage: '已收定金',
  },
  payMethod: {
    id: 'order.payMethod',
    defaultMessage: '支付方式',
  },
  orderId: {
    id: 'order.orderId',
    defaultMessage: '订单编号',
  },
  oneMoreOrder: {
    id: 'order.oneMoreOrder',
    defaultMessage: '再来一单',
  },
  payImmediately: {
    id: 'order.payImmediately',
    defaultMessage: '立即支付',
  },
  deliveryPrice: {
    id: 'order.deliveryPrice',
    defaultMessage: '配送费',
  },
  dishBoxPrice: {
    id: 'order.dishBoxPrice',
    defaultMessage: '餐盒费',
  },
  saleTax: {
    id: 'order.saleTax',
    defaultMessage: '消费税',
  },
  lowestConsumption: {
    id: 'order.lowestConsumption',
    defaultMessage: '最低消费差额附加费',
  },
  serviceCharge: {
    id: 'order.serviceCharge',
    defaultMessage: '服务费',
  },
  reservedSuccessfully: {
    id: 'order.reservedSuccessfully',
    defaultMessage: '预定成功',
  },
  noShow: {
    id: 'order.noShow',
    defaultMessage: '未到店',
  },
  reservationFailed: {
    id: 'order.reservationFailed',
    defaultMessage: '预订失败',
  },
  unpaid: {
    id: 'order.unpaid',
    defaultMessage: '未支付',
  },
  confirming: {
    id: 'order.confirming',
    defaultMessage: '确认中',
  },
  cancelled: {
    id: 'order.cancelled',
    defaultMessage: '取消预订',
  },
  checkedIn: {
    id: 'order.checkedIn',
    defaultMessage: '已到店',
  },
  confirmed: {
    id: 'order.confirmed',
    defaultMessage: '已确认',
  },
  rejected: {
    id: 'order.rejected',
    defaultMessage: '已拒绝',
  },
  needToPay: {
    id: 'order.needToPay',
    defaultMessage: '还需付',
  },
  selectBenefit: {
    id: 'dialog.selectBenefit',
    defaultMessage: '该商品可参加以下优惠',
  },
  wholeBenefitSelect: {
    id: 'dialog.wholeBenefitSelect',
    defaultMessage: '选择整单商品优惠',
  },
  applyProductType: {
    id: 'dialog.applyProductType',
    defaultMessage: '查看适用商品',
  },
  notApplyProductType: {
    id: 'dialog.notApplyProductType',
    defaultMessage: '查看不适用商品',
  },
  applyProductRange: {
    id: 'dialog.applyProductRange',
    defaultMessage: '商品适用范围',
  },
  isKoubei: {
    id: 'isKoubei',
    defaultMessage: '开始口碑秒付',
  },
  chooseCoupon: {
    id: 'chooseCoupon',
    defaultMessage: '选择优惠券',
  },
  orderSettlement: {
    id: 'orderSettlement',
    defaultMessage: '订单结算',
  },
  ordertableType: {
    id: 'order.tableType',
    defaultMessage: '{pNum}人桌',
  },
  orderlastTable: {
    id: 'order.lastTable',
    defaultMessage: '剩余{count}桌',
  },
  ordernoTablePrompt: {
    id: 'order.noTablePrompt',
    defaultMessage: '没有可用桌台',
  },
  orderoccupied: {
    id: 'order.occupied',
    defaultMessage: '该桌台已被占用',
  },
  orderselectTable: {
    id: 'order.selectTable',
    defaultMessage: '选择桌台',
  },
  orderconfirm: {
    id: 'order.confirm',
    defaultMessage: '确定',
  },
  orderquicklyComeShop: {
    id: 'order.quicklyComeShop',
    defaultMessage: '尽快到店',
  },
  orderquicklySend: {
    id: 'order.quicklySend',
    defaultMessage: '尽快送达',
  },
  ordergotoStore: {
    id: 'order.gotoStore',
    defaultMessage: '到店',
  },
  ordertakeFood: {
    id: 'order.takeFood',
    defaultMessage: '取餐',
  },
  orderArrived: {
    id: 'order.Arrived',
    defaultMessage: '送达',
  },
  orderchooseTime: {
    id: 'order.chooseTime',
    defaultMessage: '选择{postfix}时间',
  },
  ordergotoAddOn: {
    id: 'order.gotoAddOn',
    defaultMessage: '去凑单',
  },
  orderwithoutVIP: {
    id: 'order.withoutVIP',
    defaultMessage: '不使用会员价',
  },
  orderreChoose: {
    id: 'order.reChoose',
    defaultMessage: '重新挑选',
  },
  orderreExchange: {
    id: 'order.reExchange',
    defaultMessage: '重新换购',
  },
  ordergotoChoose: {
    id: 'order.gotoChoose',
    defaultMessage: '去挑选',
  },
  ordergotoExchange: {
    id: 'order.gotoExchange',
    defaultMessage: '去换购',
  },
  orderAdapt: {
    id: 'order.Adapt',
    defaultMessage: '所用商品适用',
  },
  ordercheckNoAdapt: {
    id: 'order.checkNoAdapt',
    defaultMessage: '查看不适用商品',
  },
  ordercheckAdapt: {
    id: 'order.checkAdapt',
    defaultMessage: '查看适用商品',
  },
  orderMutex: {
    id: 'order.Mutex',
    defaultMessage: '本活动与优惠券互斥',
  },
  ordernoAdaptCoupon: {
    id: 'order.noAdaptCoupon',
    defaultMessage: '不使用优惠券',
  },
  orderselectedGift: {
    id: 'order.selectedGift',
    defaultMessage: '已选赠品',
  },
  orderexchangedGoods: {
    id: 'order.exchangedGoods',
    defaultMessage: '已换购商品',
  },
  orderfillToCut: {
    id: 'order.fillToCut',
    defaultMessage: '满减',
  },
  orderfillToDiscount: {
    id: 'order.fillToDiscount',
    defaultMessage: '满折',
  },
  orderfillToGive: {
    id: 'order.fillToGive',
    defaultMessage: '满赠',
  },
  orderExchange: {
    id: 'order.Exchange',
    defaultMessage: '换购',
  },
  orderVIPPrice: {
    id: 'order.VIPPrice',
    defaultMessage: '会员价',
  },
  modify: {
    id: 'order.modify',
    defaultMessage: '修改',
  },
  orderwithoutShare: {
    id: 'order.withoutShare',
    defaultMessage: '不与整单优惠共享',
  },
  orderchooseActivity: {
    id: 'order.chooseActivity',
    defaultMessage: '请选择要参与的活动',
  },
  orderwithoutActivity: {
    id: 'order.withoutActivity',
    defaultMessage: '不参与促销活动',
  },
  ordercomfirmJoinDiscount: {
    id: 'order.comfirmJoinDiscount',
    defaultMessage: "此促销与优惠券互斥, 参与促销将重置优惠券, 确认参与促销?'",
  },
  ordermutexOfDiscount: {
    id: 'order.mutexOfDiscount',
    defaultMessage: '满减优惠与折扣商品不可同享',
  },
  ordercomfirmChange: {
    id: 'order.comfirmChange',
    defaultMessage: '更改可能导致部分商品不能参与优惠，确定更改吗？',
  },
  orderchooseDiscount: {
    id: 'order.chooseDiscount',
    defaultMessage: '选择参与商品优惠',
  },
  orderbalance: {
    id: 'order.balance',
    defaultMessage: '余额：',
  },
  ordergiftCard: {
    id: 'order.giftCard',
    defaultMessage: '礼品卡抵扣',
  },
  orderToplimit: {
    id: 'order.Toplimit',
    defaultMessage: '已到添加上限',
  },
  orderInsufficient: {
    id: 'order.Insufficient',
    defaultMessage: '库存不足',
  },
  orderranOut: {
    id: 'order.ranOut',
    defaultMessage: '已售罄',
  },
  orderchooseStandards: {
    id: 'order.chooseStandards',
    defaultMessage: '选规格',
  },
  orderchooseDishs: {
    id: 'order.chooseDishs',
    defaultMessage: '选子菜',
  },
  orderExchanged: {
    id: 'order.exchanged',
    defaultMessage: '已换购',
  },
  orderappointedGoods: {
    id: 'order.appointedGoods',
    defaultMessage: '指定商品',
  },
  orderChoosed: {
    id: 'order.Choosed',
    defaultMessage: '选好啦',
  },
  orderFilled: {
    id: 'order.Filled',
    defaultMessage: '凑好啦',
  },
  orderselectPayWay: {
    id: 'order.selectPayWay',
    defaultMessage: '请选择支付方式',
  },
  ordertable: {
    id: 'order.table',
    defaultMessage: '桌台',
  },
  orderfulled: {
    id: 'order.fulled',
    defaultMessage: '已满',
  },
  ordergoOnPurchase: {
    id: 'order.goOnPurchase',
    defaultMessage: '单品再买',
  },
  orderchooseTable: {
    id: 'order.chooseTable',
    defaultMessage: '选择桌台',
  },
  orderplsChooseTable: {
    id: 'order.plsChooseTable',
    defaultMessage: '请选择桌台',
  },
  ordertableOccupied: {
    id: 'order.tableOccupied',
    defaultMessage: '该桌台已被占用',
  },
  ordernoFreeTable: {
    id: 'order.noFreeTable',
    defaultMessage: '没有可用桌台',
  },
  orderchoosedCount: {
    id: 'order.choosedCount',
    defaultMessage: '已选{count}份',
  },
  orderpeopleNumber: {
    id: 'order.peopleNumber',
    defaultMessage: '就餐人数',
  },
  orderchooseNumber: {
    id: 'order.chooseNumber',
    defaultMessage: '选择人数',
  },
  ordernumberPlate: {
    id: 'order.numberPlate',
    defaultMessage: '号牌',
  },
  orderchooseNumberPlate: {
    id: 'order.chooseNumberPlate',
    defaultMessage: '请选择号牌',
  },
  ordermutexWithDiscount: {
    id: 'order.mutexWithDiscount',
    defaultMessage: '当前选择优惠与整单优惠不能通用，是否取消整单优惠，选择优惠券',
  },
  ordermutexWithAddPrice: {
    id: 'order.mutexWithAddPrice',
    defaultMessage: '当前选择优惠与单商品优惠/加价购不能通用，是否取消单商品优惠/加价购，选择优惠券',
  },
  ordername: {
    id: 'order.name',
    defaultMessage: '姓名：',
  },
  ordername1: {
    id: 'order.name1',
    defaultMessage: '姓名',
  },
  orderinputName: {
    id: 'order.inputName',
    defaultMessage: '请输入姓名',
  },
  orderSex: {
    id: 'order.Sex',
    defaultMessage: '性别：',
  },
  orderSex1: {
    id: 'order.Sex1',
    defaultMessage: '性别',
  },
  orderWoman: {
    id: 'order.Woman',
    defaultMessage: '女士',
  },
  orderMan: {
    id: 'order.Man',
    defaultMessage: '先生',
  },
  orderPN: {
    id: 'order.PN',
    defaultMessage: '手机号',
  },
  orderinputPN: {
    id: 'order.inputPN',
    defaultMessage: '请输入手机号码',
  },
  orderaddress: {
    id: 'order.address',
    defaultMessage: '可选收货地址',
  },
  orderoutOfRange: {
    id: 'order.outOfRange',
    defaultMessage: '不在配送范围内',
  },
  ordernoAddress: {
    id: 'order.noAddress',
    defaultMessage: '主人还没有收货地址',
  },
  ordergotoAdd: {
    id: 'order.gotoAdd',
    defaultMessage: '快来添加一个吧～',
  },
  orderaddAddressPrompt: {
    id: 'order.addAddressPrompt',
    defaultMessage: '如需新增，请删除或修改已有地址',
  },
  orderaddAddress: {
    id: 'order.addAddress',
    defaultMessage: '新增地址',
  },
  orderTelephoneNumber: {
    id: 'order.TelephoneNumber',
    defaultMessage: '联系电话：',
  },
  orderTelephoneNumber1: {
    id: 'order.TelephoneNumber1',
    defaultMessage: '联系电话',
  },
  orderSave: {
    id: 'order.Save',
    defaultMessage: '保存',
  },
  orderwayOfGetFood: {
    id: 'order.wayOfGetFood',
    defaultMessage: '取餐方式',
  },
  ordertoTable: {
    id: 'order.toTable',
    defaultMessage: '送餐到桌',
  },
  orderselfTake: {
    id: 'order.selfTake',
    defaultMessage: '前台自取',
  },
  orderusePointsToDiscount: {
    id: 'order.usePointsToDiscount',
    defaultMessage: '可用{integralValue}积分抵扣',
  },
  orderusePointsToDiscount1: {
    id: 'order.usePointsToDiscount1',
    defaultMessage: '可用{integralValue}捞币抵扣',
  },
  orderplsInputName: {
    id: 'order.plsInputName',
    defaultMessage: '请输入姓名：',
  },
  orderPS: {
    id: 'order.PS',
    defaultMessage: '备注：',
  },
  orderExchangeDiscount: {
    id: 'order.ExchangeDiscount',
    defaultMessage: '换促销',
  },
  ordertopping: {
    id: 'order.topping',
    defaultMessage: '配料',
  },
  ordertablewareNumber: {
    id: 'order.tablewareNumber',
    defaultMessage: '餐具份数',
  },
  ordernoTableware: {
    id: 'order.noTableware',
    defaultMessage: '无需餐具',
  },
  orderRecommend: {
    id: 'order.Recommend',
    defaultMessage: '推荐',
  },
  orderTablewares: {
    id: 'order.Tablewares',
    defaultMessage: '（筷子、刀、勺、吸管）',
  },
  orderinputPrompt1: {
    id: 'order.inputPrompt1',
    defaultMessage: '请输入大于0的数字',
  },
  orderinputPrompt2: {
    id: 'order.inputPrompt2',
    defaultMessage: '不能超过99份',
  },
  orderuseable: {
    id: 'order.useable',
    defaultMessage: '所有商品可用',
  },
  ordercheckUseable: {
    id: 'order.checkUseable',
    defaultMessage: '查看适用商品',
  },
  ordertoJoinDiscount: {
    id: 'order.toJoinDiscount',
    defaultMessage: '选择参与整单优惠',
  },
  orderTheTotalDishs: {
    id: 'order.totalTheDishs',
    defaultMessage: '共计{dishCount}份菜',
  },
  otherInfo: {
    id: 'otherInfo',
    defaultMessage: '其他信息',
  },
  orderGetNumber: {
    id: 'order.GetNumber',
    defaultMessage: '{createTime} 取号',
  },
  orderQueuePrompt: {
    id: 'order.QueuePrompt',
    defaultMessage: '听到叫号请到迎宾台，过号作废',
  },
  orderDinnerStateUseMemberIntegral: {
    id: 'orderDinner.UseMemberIntegral',
    defaultMessage: '使用会员积分',
  },
  orderDinnerStateMyIntegral: {
    id: 'orderDinner.MyIntegral',
    defaultMessage: '我的积分',
  },
  orderDinnerStateEnjoyMembershipPrice: {
    id: 'orderDinner.EnjoyMembershipPrice',
    defaultMessage: '享受会员价',
  },
  orderDinnerStateWholeBenefitDiscount: {
    id: 'orderDinner.WholeBenefit',
    defaultMessage: '整单商品优惠',
  },
  orderOnlinePayment: {
    id: 'order.OnlinePayment',
    defaultMessage: '在线支付',
  },
  orderOfflinePayment: {
    id: 'order.OfflinePayment',
    defaultMessage: '线下支付',
  },
  orderCashOnDelivery: {
    id: 'order.CashOnDelivery',
    defaultMessage: '货到付款',
  },
  orderEnjoyed: {
    id: 'order.Enjoyed',
    defaultMessage: '已享',
  },
  orderExclusivePrice: {
    id: 'order.ExclusivePrice',
    defaultMessage: '专享价',
  },
  orderInvoicingWarn: {
    id: 'order.InvoicingWarn',
    defaultMessage: '该订单所在门店不支持开发票',
  },
  orderWaitingInLine: {
    id: 'order.WaitingInLine',
    defaultMessage: '排队中',
  },
  orderAlreadyAdmitted: {
    id: 'order.AlreadyAdmitted',
    defaultMessage: '已入场',
  },
  orderAbolished: {
    id: 'order.Abolished',
    defaultMessage: '已作废',
  },
  orderCancelled: {
    id: 'order.Cancelled',
    defaultMessage: '已取消',
  },
  orderWatingForTables: {
    id: 'order.WatingForTables',
    defaultMessage: '前面{number}桌等待',
  },
  orderGoodsNotInvolved: {
    id: 'order.GoodsNotInvolved',
    defaultMessage: '未参与加价购的商品',
  },
  orderManualInput: {
    id: 'order.ManualInput',
    defaultMessage: '手动输入',
  },
  orderToDay: {
    id: 'orderToDay',
    defaultMessage: '今日',
  },
  orderNoUseableShopTime: {
    id: 'orderNoUseableShopTime',
    defaultMessage: '没有可用到店时间',
  },
  orderNoUseableSendTime: {
    id: 'orderNoUseableSendTime',
    defaultMessage: '没有可用送达时间',
  },
  orderComeToShop: {
    id: 'orderComeToShop',
    defaultMessage: '到店取餐',
  },
  orderSelectTableWare: {
    id: 'orderSelectTableWare',
    defaultMessage: '推荐选无需餐具，未选择',
  },
  orderAdeptGoods: {
    id: 'orderAdeptGoods',
    defaultMessage: '适用商品',
  },
  orderNoAdeptGoods: {
    id: 'orderNoAdeptGoods',
    defaultMessage: '不适用商品',
  },
  orderSelectPlate: {
    id: 'orderSelectPlate',
    defaultMessage: '选择号牌',
  },
  orderSelectTable: {
    id: 'orderSelectTable',
    defaultMessage: '选择桌台',
  },
  orderTotalPrice: {
    id: 'orderTotalPrice',
    defaultMessage: '总金额',
  },
  orderDiscountPropmpt: {
    id: 'orderDiscountPropmpt',
    defaultMessage: '折扣单品每单限一份，按照折扣最大力度的单品享受，超出部分按照原价购买。',
  },
  orderCannotGetDiscount: {
    id: 'orderCannotGetDiscount',
    defaultMessage: '您选择的配送时段在优惠时段以外，无法享受优惠',
  },
  orderGetPot: {
    id: 'orderGetPot',
    defaultMessage: '锅底为必选菜品，请确认已选锅底',
  },
  returnToDish: {
    id: 'returnToDish',
    defaultMessage: '回到点餐页',
  },
  notOrderMustDish: {
    id: 'notOrderMustDish',
    defaultMessage: '您还未选必点菜',
  },
  orderLowestSpend: {
    id: 'orderLowestSpend',
    defaultMessage: '本桌最低消费{lowestConsumption}元，还差{tradeAmount}元',
  },
  orderPersons: {
    id: 'orderPersons',
    defaultMessage: '{count}人',
  },
  orderPersonAbove: {
    id: 'orderPersonAbove',
    defaultMessage: '人以上',
  },
  orderTableQuantity: {
    id: 'orderTableQuantity',
    defaultMessage: '{count}桌',
  },
  orderTableName: {
    id: 'order.tableName',
    defaultMessage: '{pNum}人桌(余下{count}桌)',
  },
  buyMore: {
    id: 'order.buyMore',
    defaultMessage: '再买',
  },
  Subtotal: {
    id: 'order.Subtotal',
    defaultMessage: '小计',
  },
  canDiscount: {
    id: 'order.canDiscount',
    defaultMessage: '可享优惠',
  },
  yuan: {
    id: 'order.yuan',
    defaultMessage: '元',
  },
  reduce: {
    id: 'order.reduce',
    defaultMessage: '减',
  },
  enjoy: {
    id: 'order.enjoy',
    defaultMessage: '享',
  },
  add: {
    id: 'order.add',
    defaultMessage: '加',
  },
  choose: {
    id: 'order.choose',
    defaultMessage: '选',
  },
  discount: {
    id: 'order.discount',
    defaultMessage: '折',
  },
  yuanBuy: {
    id: 'order.yuanBuy',
    defaultMessage: '元换购商品',
  },
  gifts: {
    id: 'order.gifts',
    defaultMessage: '份赠品',
  },
  full: {
    id: 'order.full',
    defaultMessage: '满',
  },
  can: {
    id: 'order.can',
    defaultMessage: '可',
  },
  already: {
    id: 'order.already',
    defaultMessage: '已',
  },
  less: {
    id: 'order.less',
    defaultMessage: '还差',
  },
  orderNotSelectedGiftCard: {
    id: 'orderNotSelectedGiftCard',
    defaultMessage: '未选择礼品卡',
  },
  orderSelectDinnerPeople: {
    id: 'orderSelectDinnerPeople',
    defaultMessage: '请选择就餐人数',
  },
  orderUnSelectPlate: {
    id: 'orderUnSelectPlate',
    defaultMessage: '未选择号牌',
  },
  orderOpenSelfGetSwitch: {
    id: 'orderOpenSelfGetSwitch',
    defaultMessage: '请打开前台自取开关',
  },
  orderUnSelectTableInfo: {
    id: 'orderUnSelectTableInfo',
    defaultMessage: '未选择桌台信息',
  },
  orderCannotUseWXCard: {
    id: 'orderCannotUseWXCard',
    defaultMessage: '订单不可使用微信卡券',
  },
  orderCannotUsePrompt: {
    id: 'orderCannotUsePrompt',
    defaultMessage: '非常抱歉，线下支付不可使用微信卡券',
  },
  orderHelperSelect: {
    id: 'orderHelperSelect',
    defaultMessage: '请选择',
  },
  orderHelperTime: {
    id: 'orderHelperTime',
    defaultMessage: '时间',
  },
  next: {
    id: 'order.next',
    defaultMessage: '下一份',
  },
  lowestPrice: {
    id: 'order.lowestPrice',
    defaultMessage: '最低价',
  },
  chooseNext: {
    id: 'order.chooseNext',
    defaultMessage: '选择下一份',
  },
  every: {
    id: 'order.every',
    defaultMessage: '每',
  },
  orderMemoIsRequired: {
    id: 'orderMemoIsRequired',
    defaultMessage: '订单备注不能为空',
  },
  quickMemo1: {
    id: 'quickMemo1',
    defaultMessage: '挂门把手上',
  },
  quickMemo2: {
    id: 'quickMemo2',
    defaultMessage: '放前台',
  },
  quickMemo3: {
    id: 'quickMemo3',
    defaultMessage: '放门口',
  },
  quickMemo4: {
    id: 'quickMemo4',
    defaultMessage: '请电话联系我',
  },
  orderNumber: {
    id: 'orderNumber',
    defaultMessage: '个订单',
  },
  total: {
    id: 'total',
    defaultMessage: '共',
  },
  yuan: {
    id: 'yuan',
    defaultMessage: '元',
  },
  orderAllChoose: {
    id: 'orderAllChoose',
    defaultMessage: '本页全选',
  },
  noOrder: {
    id: 'noOrder',
    defaultMessage: '当前门店没有订单',
  },
  allOrdersLoaded: {
    id: 'allOrdersLoaded',
    defaultMessage: '已加载所有订单',
  },
  loadMore: {
    id: 'loadMore',
    defaultMessage: '点击加载更多',
  },
  openInvoice: {
    id: 'openInvoice',
    defaultMessage: '当前门店未开通发票业务，请与商家联系',
  },
  orderUsecard: {
    id: 'order.useDiscountCard',
    defaultMessage: '使用折扣卡',
  },
  orderDiscounts: {
    id: 'order.discounts',
    defaultMessage: '折扣不与商品优惠、会员价同享',
  },
  orderNoCards: {
    id: 'order.noCards',
    defaultMessage: '暂无可用卡',
  },
  orderInvalidTaxIdentyNo: {
    id: 'order.invalidTaxIdentyNo',
    defaultMessage: '纳税人识别号信息不允许含有特殊字符',
  },
  orderInvalidReceipt: {
    id: 'order.invalidReceipt',
    defaultMessage: '发票抬头信息不允许含有特殊字符',
  },
  orderInvalidNote: {
    id: 'order.invalidNote',
    defaultMessage: '订单备注信息不允许含有特殊字符',
  },
});



// WEBPACK FOOTER //
// ./src/intl/messages/order/index.js